/* eslint-disable camelcase */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Input, Row, Col } from "antd";
import moment from "moment";

import { getGatewayCallbacks } from "../../../redux/actions/Gateway";

import generateQuery, { handleSearch as search } from "../../../util/table";
import PageLimitSwitch from "../../../components/PageLimitSwitch";

const columns = [
  {
    title: "Created",
    dataIndex: "created_at",
    render: (date) => <span>{moment(date).format("DD/MM/YY h:mm:ss a")}</span>,
    sorter: true,
    search: false,
  },
  {
    title: "Gateway reference",
    dataIndex: "gatewayReference",
    sorter: true,
    width: 200,
  },
  {
    title: "Ip address",
    dataIndex: "ipAddress",
    sorter: true,
    width: 200,
  },
  {
    title: "attempts",
    dataIndex: "attempts",
    sorter: true,
  },
  {
    title: "Level",
    dataIndex: "level",
    sorter: true,
  },
  {
    title: "Message",
    dataIndex: "message",
    sorter: true,
  },
  {
    title: "Gateway Reference",
    dataIndex: "kitegatewayReference",
    sorter: true,
  },
  {
    title: "Service Type",
    dataIndex: "serviceType",
    sorter: true,
  },
  {
    title: "Processor name",
    dataIndex: "processorName",
    sorter: true,
    width: 150,
  },
  {
    title: "Processor Reference",
    dataIndex: "processorReference",
    sorter: true,
  },
  {
    title: "Request Body",
    dataIndex: "requestBody",
    sorter: true,
  },
  {
    title: "Response Status Code",
    dataIndex: "responseStatusCode",
    sorter: true,
  },
  {
    title: "Status",
    dataIndex: "status",
    sorter: true,
  },
  {
    title: "Transaction Amount",
    dataIndex: "transactionAmount",
    sorter: true,
  },
  {
    title: "Transaction Currency",
    dataIndex: "transactionCurrency",
    sorter: true,
  },
  {
    title: "Transaction Status",
    dataIndex: "transactionStatus",
    sorter: true,
  },
  {
    title: "Transaction Type",
    dataIndex: "transactionType",
    sorter: true,
  },
  {
    title: "Url",
    dataIndex: "url",
    sorter: true,
  },
];

const Callbacks = () => {
  const dispatch = useDispatch();
  const { data, pageSize, currentPage, totalRecords, loading } = useSelector(
    ({ gateway }) => gateway.gateway_callbacks
  );
  const [searchParams, setSearchParams] = useState("");

  useEffect(() => {
    const pagination = `page=${currentPage}&limit=${pageSize}`;
    dispatch(getGatewayCallbacks(pagination));
  }, [dispatch, pageSize, currentPage]);

  const dataSource = data?.map(
    ({
      _id,
      attempts,
      ip_address: ipAddress,
      level,
      message,
      kitegateway_reference: kitegatewayReference,
      service_type: serviceType,
      processor_name: processorName,
      processor_reference: processorReference,
      request_body: requestBody,
      response_status_code: responseStatusCode,
      status,
      transaction_amount: transactionAmount,
      transaction_currency: transactionCurrency,
      transaction_status: transactionStatus,
      transaction_type: transactionType,
      url,
      created_at,
      updated_at,
    }) => ({
      key: _id,
      attempts,
      ipAddress,
      level,
      message,
      kitegatewayReference,
      serviceType,
      processorName,
      processorReference,
      requestBody,
      responseStatusCode,
      status,
      transactionAmount,
      transactionCurrency,
      transactionStatus,
      transactionType,
      url,
      created_at,
      updated_at,
    })
  );

  const handleOnChange = (pagination, filters, sorter) => {
    dispatch(
      getGatewayCallbacks(
        generateQuery(pagination, filters, sorter, searchParams)
      )
    );
  };

  const handleSearch = (searchValue) => {
    const query = search(searchValue, dispatch, getGatewayCallbacks, columns);
    setSearchParams(query);
  };

  const props = {
    pagination: false,
    onChange: handleOnChange,
    loading,
    columns,
    dataSource,
  };

  return (
    <div>
      <h2 className="title gx-mb-4">Callbacks</h2>
      <div className="gx-d-flex justify-content-center">
        <Input.Search
          placeholder="Search Callbacks"
          enterButton
          allowClear
          onSearch={handleSearch}
        />
      </div>
      <div className="gx-d-flex justify-content-center">
        <Table className="gx-table-responsive striped-table" {...props} />
      </div>
      <Row className="pagination">
        <Col md={12}>
          <PageLimitSwitch
            resourceType="gateway_callbacks"
            limit={pageSize}
            limits={[10, 100, 200, 500, 1000, 2000, 5000, 10000]}
            totalRecords={totalRecords}
            currentPage={currentPage}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Callbacks;
